import { createContext, useContext, Dispatch, SetStateAction } from 'react'

import { PostLeadResponse, LeadVariant, LeadData, Lead } from 'modules/lead/types'
import { EMPTY_POST_LEAD_RESPONSE, EMPTY_LEAD_DATA, EMPTY_LEAD } from 'modules/lead/constants'

export interface LeadState {
  lead: Lead,
  leadVariant: LeadVariant | null,
  setLeadVariant: Dispatch<SetStateAction<LeadVariant | null>>,
  postLead: {
    response: PostLeadResponse,
    setResponse: Dispatch<SetStateAction<PostLeadResponse>>,
    hasError: boolean,
    setHasError: Dispatch<SetStateAction<boolean>>,
    isLoading: boolean,
    setIsLoading: Dispatch<SetStateAction<boolean>>
  },
  leadData: {
    showConfirm: boolean,
    setShowConfirm: Dispatch<SetStateAction<boolean>>,
    isLoading: boolean,
    setIsLoading: Dispatch<SetStateAction<boolean>>,
    data: LeadData,
    setData: Dispatch<SetStateAction<LeadData>>
  }
}

export const INITIAL_STATE: LeadState = {
  lead: EMPTY_LEAD,
  leadVariant: null,
  setLeadVariant: () => void 0,
  postLead: {
    response: EMPTY_POST_LEAD_RESPONSE,
    setResponse: () => void 0,
    hasError: false,
    setHasError: () => void 0,
    isLoading: false,
    setIsLoading: () => void 0
  },
  leadData: {
    showConfirm: false,
    setShowConfirm: () => void 0,
    isLoading: true,
    setIsLoading: () => void 0,
    data: EMPTY_LEAD_DATA,
    setData: () => void 0
  }
}

export const LeadContext = createContext(INITIAL_STATE)

export const useLeadContext = () => useContext(LeadContext)
export const usePostLeadContext = () => useLeadContext().postLead
export const useLeadDataContext = () => useLeadContext().leadData
